export default __webpack_public_path__ + "static/media/6-min.96e9230c.jpg";